var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoTemplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-templates 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-templates"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M54.1833 24.9446H43.5536C40.6304 24.9446 38.2387 22.5529 38.2387 19.6298V9M54.1833 24.9446V46.2042C54.1833 52.0505 49.3999 56.8339 43.5536 56.8339H22.2941C16.4477 56.8339 11.6643 52.0505 11.6643 46.2042V19.6298C11.6643 13.7834 16.4477 9 22.2941 9H38.2387M54.1833 24.9446L38.2387 9",
    stroke: "#D1D5DB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoTemplate);
export default __webpack_public_path__ + "static/media/icon-no-template.b9f5081740ec0263663403a5a5da6e97.svg";
export { ForwardRef as ReactComponent };